<template>
  <div class="card" v-bind:key="card.flipped" :class="{ cardmatch: card.matched }">
    <img  :src="card.image" height="160px" width="180px"/>
    <p>{{card.name}}</p>
  </div>
</template>

<script>
    export default {
      name: "app-card-matched",
      props: {
        card: {
          type: Object
        }
      }
    }
</script>

<style scoped>

  ul {
    padding-left: 0;
    display: flex;
    flex-flow: row wrap;
  }

  li {
    list-style-type: none;
    padding: 10px 10px;
    transition: all 0.3s ease;
  }

  .card {
    display: block;
    width: 230px;
    height: 230px;
    padding-top: 35px;
    border-radius: 7px;
    text-align: center;
    line-height: 27px;
    cursor: pointer;
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    -webkit-box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    -moz-box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    box-shadow: 9px 10px 22px -8px rgba(209,193,209,.5);
    background-color: #302f30;
    will-change: transform;
    animation: match-keyframes 5s ease-out ;
    z-index: 5;
    position: absolute;
    top: 40%;
    left: 50%;
    margin-top: -115px;
    margin-left: -115px;
  }

  @keyframes match-keyframes {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(3);
    }
    100% {
      transform: scale(3) ;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/app-card-matched.vue